import { ArrowLeft, Upload, Save } from "lucide-react";

export function BuilderTopBar({ form, setForm, editName, setEditName, onSave, onBack, handlePdfUpload }) {
  return (
    <div className="h-15 bg-white border-b border-gray-200 flex items-center px-5 gap-3.5 shadow-sm shrink-0 z-10">
      <button onClick={onBack} className="flex items-center gap-1.5 border-none bg-transparent cursor-pointer text-gray-500 text-sm px-2 py-2 rounded-lg hover:bg-gray-100 transition-colors">
        <ArrowLeft size={16} /> Back
      </button>
      <div className="w-px h-6 bg-gray-200" />

      {editName ? (
        <input autoFocus value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} onBlur={() => setEditName(false)} onKeyDown={(e) => e.key === "Enter" && setEditName(false)} className="border-none outline-none text-[17px] font-bold text-gray-900 bg-transparent min-w-50" />
      ) : (
        <h2 onClick={() => setEditName(true)} className="m-0 text-[17px] font-bold text-gray-900 cursor-text px-2 py-1 rounded-md hover:bg-gray-100 transition-colors">
          {form.name}
        </h2>
      )}

      <div className="flex-1" />

      <label
        className={`
          flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-medium cursor-pointer
          ${form.file?.original_name || form.pdfName ? "border border-green-300 bg-green-50 text-green-800" : "border border-dashed border-gray-300 bg-transparent text-gray-500"}
        `}
      >
        <Upload size={14} />
        {form.file?.original_name || form.pdfName || "Upload PDF"}
        <input
          type="file"
          accept=".pdf"
          className="hidden"
          disabled={form.file?.original_name || form.pdfName ? true : false}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) handlePdfUpload(file);
          }}
        />
      </label>

      <button onClick={onSave} className="flex items-center gap-2 bg-[#dc2626] text-white border-none px-5 py-2.5 rounded-lg cursor-pointer text-sm font-semibold shadow-md hover:opacity-90 transition-opacity">
        <Save size={15} /> Save Form
      </button>
    </div>
  );
}
